module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/vectors/term-bg-5-42d62a31611cdc9ad3221113cedea3d4.jpg";